import { GET_LOGIN_CAPTCHA, GET_LOGIN_ERROR, GET_POPUP_DATA, SET_AGENCYLIST, SET_ALLUSERDATA, SET_BANKLIST, SET_CURRENT_USER, SET_EVENTPARTNAMELIST, SET_MARKETNAMELIST, SET_SHOWLEFT, SHOW_ADVERTISEMENT } from '../actions/types';
import { isEmpty } from '../cores';

const initialState = {
    showAdvertisement: false,
    isAuthenticated: false,
    loginError: '',
    data: {},
    allData: {},
    captchaData: {},
    popup: [],
    agencyList:[],
    marketNameList:[],
    eventpartNameList:[],
    bankList: [
        {
            _id: "6568127bde886f2ff3e44664",
            bankName: "국민은행",
            status: true,
            img: "6568127bde886f2ff3e44664.png",
            __v: 0
        },
        {
            _id: "656815078aafa43c876bdfed",
            bankName: "SC제일은행",
            status: true,
            img: "656815078aafa43c876bdfed.png",
            __v: 0
        },
        {
            _id: "656815118aafa43c876be012",
            bankName: "광주은행",
            status: true,
            img: "656815118aafa43c876be012.png",
            __v: 0
        },
        {
            _id: "656815198aafa43c876be037",
            bankName: "농협은행",
            status: true,
            img: "656815198aafa43c876be037.png",
            __v: 0
        },
        {
            _id: "656815228aafa43c876be03d",
            bankName: "부산은행",
            status: true,
            img: "656815228aafa43c876be03d.png",
            __v: 0
        },
        {
            _id: "6568152a8aafa43c876be062",
            bankName: "새마을금고",
            status: true,
            img: "6568152a8aafa43c876be062.png",
            __v: 0
        },
        {
            _id: "656815318aafa43c876be087",
            bankName: "신한은행",
            status: true,
            img: "656815318aafa43c876be087.png",
            __v: 0
        },
        {
            _id: "6568153a8aafa43c876be0ac",
            bankName: "우리은행",
            status: true,
            img: "6568153a8aafa43c876be0ac.png",
            __v: 0
        },
        {
            _id: "6568153f8aafa43c876be0af",
            bankName: "우체국",
            status: true,
            img: "6568153f8aafa43c876be0af.png",
            __v: 0
        },
        {
            _id: "656815448aafa43c876be0d1",
            bankName: "전북은행",
            status: true,
            img: "656815448aafa43c876be0d1.png",
            __v: 0
        },
        {
            _id: "656815478aafa43c876be0d4",
            bankName: "제주은행",
            status: true,
            img: "656815478aafa43c876be0d4.png",
            __v: 0
        },
        {
            _id: "6568154b8aafa43c876be0f6",
            bankName: "카카오뱅크",
            status: true,
            img: "6568154b8aafa43c876be0f6.png",
            __v: 0
        },
        {
            _id: "656815568aafa43c876be11b",
            bankName: "하나은행",
            status: true,
            img: "656815568aafa43c876be11b.png",
            __v: 0
        },
        {
            _id: "6568155a8aafa43c876be11e",
            bankName: "한국씨티은행",
            status: true,
            img: "6568155a8aafa43c876be11e.png",
            __v: 0
        }
    ],
    showleft: false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_CURRENT_USER:
            // //console.log(action.payload)
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                data: action.payload
            }
        case SHOW_ADVERTISEMENT:
            return {
                ...state,
                showAdvertisement: action.payload
            }
        case GET_LOGIN_ERROR:
            return {
                ...state,
                loginError: action.payload
            }
        case GET_LOGIN_CAPTCHA:
            return {
                ...state,
                captchaData: action.payload
            }
        case GET_POPUP_DATA:
            // //console.log("레듀서에서 내용", action.payload)
            return {
                ...state,
                popup: action.payload
            }
        case SET_BANKLIST:
            return {
                ...state,
                bankList: action.payload
            }
        case SET_AGENCYLIST:
            return {
                ...state,
                agencyList: action.payload
            }
        case SET_MARKETNAMELIST:
            return {
                ...state,
                marketNameList:action.payload
            }
        case SET_EVENTPARTNAMELIST:
            return {
                ...state,
                eventpartNameList:action.payload
            }
        case SET_ALLUSERDATA:
            return {
                ...state,
                allData: action.payload
            }
        case SET_SHOWLEFT:
            return {
                ...state,
                showleft: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/common/reducers/userReducer.js